import { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Box, Card, Typography, useTheme } from '@mui/material'
import ActivityCard from 'balkerne-components/dashboard/ActivityCard'
import DashboardMap from '../components/DashboardMap'
import SavedDrafts from 'balkerne-components/dashboard/SavedDrafts'
import AlertsCard from 'balkerne-components/dashboard/AlertsCard'
import { useDispatch } from 'react-redux'
import systemActions from '../store/system'
import { Button, Grid, Stack } from '@mui/material'
import siteMap from '../siteMap'
import Page from '../components/Page'
import { useLocation } from '../hooks/locations'
import EditIcon from '@mui/icons-material/Edit'
import { FeatureGate } from 'balkerne-core/roles'

import AddRoundedIcon from '@mui/icons-material/AddRounded'
import PropertyClimateHazardsCard from 'balkerne-components/dashboard/PropertyClimateHazardsCard'

const Property = () => {
  const history = useHistory()
  const { id: propertyId } = useParams()
  const { data: property } = useLocation(propertyId)
  const dispatch = useDispatch()

  // property: object (example)
  // {
  //     "id": 9635,
  //     "organisation_id": 1,
  //     "name": "82 Manchester Road",
  //     "type": {
  //         "id": "196c16a3-cc9d-5f28-90f2-c0272fe6a352",
  //         "is_system": true,
  //         "label": "Unknown",
  //         "created_at": "2025-11-30T21:39:24.920771"
  //     },
  //     "property_customer_reference": "3245b097-c506-4d60-8615-6264f1c14e2b",
  //     "coordinates": {
  //         "latitude": 53.58436225297437,
  //         "longitude": -2.210266880526774
  //     },
  //     "created_at": "2025-11-30T21:39:25.206944",
  //     "geometry": null,
  //     "address": {
  //         "country": "England",
  //         "town": "Heywood",
  //         "postcode": "OL10 2PN",
  //         "street": "Manchester Road"
  //     },
  //     "attributes": [],
  //     "groups": [],
  //     "insurance": {
  //         "value": 3000000,
  //     },
  //     "metadata": {
  //         "distance": null
  //     }
  // }

  useEffect(() => {
    dispatch(systemActions.setPropertyId(Number.parseInt(propertyId)))
  }, [propertyId])

  const goToEditProperty = () => {
    history.push(siteMap.EditProperty.getPath(propertyId))
  }

  const handleAddMitigation = () => {
    history.push(
      siteMap.FormList.getPath({
        typeID: 5,
        title: 'Add Mitigations',
        propertyID: propertyId,
      }),
    )
  }

  const handleCompleteChecklist = () => {
    history.push(
      siteMap.FormList.getPath({
        typeID: 7,
        title: 'Complete Checklist',
        propertyID: propertyId,
      }),
    )
  }

  return (
    <Page
      title={property?.name ?? null}
      PageActions={() => (
        <Button variant="outlined" onClick={goToEditProperty}>
          <EditIcon />
        </Button>
      )}>
      <Grid container spacing={2}>
        {/* Map */}
        <Grid item minWidth={300} xs={0} md lg={7} sx={{ display: { xs: 'none', md: 'block' } }}>
          <DashboardMap propertyId={propertyId} />
        </Grid>

        <Grid item md lg={5}>
          <Stack spacing={2}>
            {/* Climate Hazards */}
            <FeatureGate feature="projections">
              <PropertyClimateHazardsCard propertyId={propertyId} />
            </FeatureGate>
            {/* Alerts Card */}
            <FeatureGate feature="alerts">
              <AlertsCard propertyId={propertyId} />
            </FeatureGate>

            {/* Actions Card */}
            <Card>
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{ xs: 1, sm: 2 }}
                alignItems={{ sm: 'center' }}
                useFlexGap>
                <Typography variant="subtitle1" sx={{ whiteSpace: 'nowrap' }}>
                  Open Forms
                </Typography>

                {/* Button group */}
                <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ ml: { sm: 1 } }}>
                  <Button variant="outlined" size="small" className="button-drafts-1" onClick={handleCompleteChecklist}>
                    <AddRoundedIcon sx={{ width: 16, height: 16 }} />
                    Checklist
                  </Button>
                  <Button variant="outlined" size="small" className="button-drafts-1" onClick={handleAddMitigation}>
                    <AddRoundedIcon sx={{ width: 16, height: 16 }} />
                    Mitigation
                  </Button>
                  {/* add more buttons if needed */}
                </Stack>
              </Stack>

              <hr style={{ marginBottom: 0 }}></hr>
              <SavedDrafts property_id={propertyId} />
            </Card>

            {/* Activity Card */}
            <ActivityCard property_id={propertyId} />
          </Stack>
        </Grid>
      </Grid>
    </Page>
  )
}

export default Property
